import type { IconData } from '@stacksjs/iconify-core'

export const noteAdd: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M24 24v472h294.627L496 318.627V24Zm32 32h408v216H272v192H56Zm249.373 408H304V304h160v1.373Z\"/><path fill=\"currentColor\" d=\"M208 288v-80h80v-32h-80V96h-32v80H96v32h80v80z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default noteAdd
